import { BlogSectionLink } from "../../Services/blog.service";

interface BlogPageSitelinksProps {
  sectionLinks: BlogSectionLink[];
}

function BlogPageSitelinks({ sectionLinks }: BlogPageSitelinksProps) {
  if (!sectionLinks.length) {
    return null;
  }

  return (
    <nav aria-label="Page sections" className="medium-article-sitelinks">
      <p className="medium-article-sitelinks-title">On this page</p>
      <ul className="medium-article-sitelinks-list">
        {sectionLinks.map((sectionLink) => (
          <li key={sectionLink.id}>
            <a
              className="medium-article-sitelinks-link"
              href={sectionLink.href}
            >
              {sectionLink.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default BlogPageSitelinks;
